import React, { useState, useEffect, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import CustomTooltip from '../../../Tooltip';
import PreviewOriginal from '../../../PreviewOriginal';
import { cap } from '../../../../config';
import DataComponentPromo from "../../../DataComponent/DataComponentPromo";
import { I18nContext } from 'utils/I18n/context';
import { OfferContext } from '../OfferPageContainer/OfferPageContainer';

const columnTableData = {
    header: {
        0: {className: 'text-center', style: {width: 50}},
        1: {className: 'offer-item__table-banner', style: {width: 187}},
        2: {className: 'text-center'},
        3: {className: 'text-center'}
    },
    body: {
        0: {className: 'text-center'},
        1: {className: 'offer-item__table-banner'}
    }
};

const OfferPagePromoContainers = ({ 
    containers, 
    locales, 
    headerNames, 
    loading, 
    totalPages, 
    getLocales, 
    getContainers: getContainersAction 
}) => {
    const { t } = useContext(I18nContext);
    const offerCtx = useContext(OfferContext) || {};
    const openConstructor = offerCtx.showConstructor || null;
    const { id } = useParams();
    const [state, setState] = useState({
        offerId: id,
        containers: containers || [],
        locales: locales,
        headerNames: headerNames,
        loading: loading,
        totalPages: totalPages
    });

    const staticNamesConstructors = t?.constructors || { textIframe: 'Text iframe' };

    useEffect(() => {
        const offerId = state.offerId;
        if (!offerId) return;
        getLocales({ offerId });
    }, [getLocales, state.offerId]);

    useEffect(() => {
        setState(prev => ({
            ...prev,
            offerId: id,
            loading: loading,
            containers: containers || [],
            locales: locales,
            totalPages: totalPages
        }));
    }, [id, loading, containers, locales, totalPages]);

    const showConstructor = useCallback((index) => {
        const data = state.containers[index];
        if (!data || !openConstructor) return;
        openConstructor({
            creativeType: 'container',
            creativeId: data.id,
            linkId: data.link?.id,
            type: 'container',
            codeParams: {
                width: data.width,
                height: data.height,
                text: staticNamesConstructors.textIframe
            }
        });
    }, [state.containers, staticNamesConstructors.textIframe, openConstructor]);

    const getContainers = useCallback(() => {
        let containers = [];

        state.containers.map((container, i) => {
            let itemUrl = container.link.url.slice(0, 80);
            if (itemUrl.length < container.link.url.length) {
                itemUrl += ' ...';
            }

            let itemTitle = container.link.title.slice(0,60);
            if (itemTitle.length < container.link.title.length) {
                itemTitle += ' ...';
            }

            containers.push({
                id: container.id,
                name: container.link.title,
                image: (
                    <div className="offer-item__table-img">
                        {container.link.thumbnail
                            ? (
                                <CustomTooltip id={`link-preview-${i}`} tooltip={<PreviewOriginal url={container.link.image} />} placement={'right'} theme={'preview'}>
                                    <a href={container.link.url} id={`link-preview-${i}`} target="_blank">
                                        <img src={container.link.thumbnail || cap} alt="" />
                                    </a>
                                </CustomTooltip>
                            )
                            : (
                                <a href={container.link.url} target="_blank">
                                    <img src={cap} alt="" />
                                </a>
                            )
                        }
                    </div>
                ),
                title: itemTitle,
                url:(<a href={container.link.url} target="_blank">{itemUrl}</a>),
                action: null
            });
        });

        return containers;
    }, [state.containers]);

    const onDataTableAction = useCallback((dataComponentState, actionType) => {
        getContainersAction({
            ...dataComponentState,
            offerId: state.offerId
        }, actionType);
    }, [getContainersAction, state.offerId]);

    return (
        <DataComponentPromo
            onAction={onDataTableAction}
            totalPages={state.totalPages}
            headerNames={state.headerNames}
            data={getContainers()}
            loading={state.loading}
            withoutDatepicker={true}
            textInput={true}
            alignPagination={true}
            columnData={columnTableData}
            hidden={true}
        />
    );
};

OfferPagePromoContainers.propTypes = {
    containers: PropTypes.array,
    locales: PropTypes.array,
    headerNames: PropTypes.array,
    loading: PropTypes.bool,
    totalPages: PropTypes.number,
    getLocales: PropTypes.func,
    getContainers: PropTypes.func
};

OfferPagePromoContainers.defaultProps = {
    containers: [],
    locales: [],
    headerNames: [],
    loading: false,
    totalPages: 0,
    getLocales: () => {},
    getContainers: () => {}
};

export { OfferPagePromoContainers };
